<template lang="pug">
.warning
  .title
    img.icon-warning(src="~assets/icons/warning.svg")
    span 风险提示
  .terms
    .term 1.禁止60周岁以上长者、醉酒、高血压、心脏病、眩晕症、脊柱病患者、孕妇、行动不便及其他不适合身体剧烈运动者乘坐。
    .term 2.身高1M-1.2M的儿童必须有成人陪同才能乘坐，否则谢绝乘坐。1米以下和1.2米以上儿童不得乘坐。
    .term 3.请按次序排队上下，听从工作人员指挥，不得争先恐后和翻越闸机。
    .term 4.乘坐时禁止携带易脱落、易碎物品，如手机、眼镜等，请妥善保管。
    .term 5.乘客就位背靠后，请系好安全带并配合工作人员进行安全检查。
    .term 6.设备运转中要保持正确坐姿，紧握扶手，不要擅自解开安全带。严禁抛洒杂物、乱摇乱晃，站立及做出各种危险动作。
    .term 7.请乘客朋友听从工作人员的安排，对于违反上述规定的乘客，经工作人员劝告无效者，工作人员有权终止其游玩本项目的资格。
    .term 8.在设备运行中如遇身体不适，请立即向工作人员示意，停止设备运行。
    .term 9.在设备运行中如遇突然停电或其他突发情况，请乘客切勿慌张，保持冷静，必须听从工作人员指挥，安全疏导，有序下客。
    .term 10.乘坐该设备的乘客，视为已同意并熟知了本《游玩须知》的所有条款，否则发生事故责任自负。

  
</template>
<script>
export default {
  name: 'Warning',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.warning
  +full
  background: white
  padding: pxToRem(30)
  display: flex
  //align-items: center
  flex-direction: column
  .title
    display: flex
    flex-direction: row
    align-items: center
    justify-content: flex-start
    margin-bottom: pxToRem(50)
    .icon-warning
      width: pxToRem(52)
      height: pxToRem(52)
      object-fit: contain
      margin-right: pxToRem(10)
  .terms
    flex: 1
    width: 100%
    overflow-x: hidden
    overflow-y: scroll
    .term
      font-size: 12px
</style>
